const STALE_CLIENT_ERROR_MARKERS = [
  "UnrecognizedActionError",
  "unexpected response was received from the server",
  "ChunkLoadError",
  "Loading chunk",
  "module factory is not available",
] as const;

export const NEXT_ACTION_HEADER = "next-action";
export const NEXT_ACTION_NOT_FOUND_HEADER = "x-nextjs-action-not-found";

export function isStaleClientError(message: string | undefined): boolean {
  if (!message) {
    return false;
  }

  return STALE_CLIENT_ERROR_MARKERS.some((marker) => message.includes(marker));
}

export function getStaleClientErrorMessage(
  reason: unknown
): string | undefined {
  if (reason instanceof Error) {
    return [reason.name, reason.message, reason.toString()]
      .filter(Boolean)
      .join(" ");
  }

  if (typeof reason === "string") {
    return reason;
  }

  if (reason == null) {
    return undefined;
  }

  return String(reason);
}

export function isStaleClientReason(reason: unknown): boolean {
  return isStaleClientError(getStaleClientErrorMessage(reason));
}

export function getFetchRequestHeaders(
  input: RequestInfo | URL,
  init?: RequestInit
): Headers {
  if (init?.headers) {
    return new Headers(init.headers);
  }

  if (typeof Request !== "undefined" && input instanceof Request) {
    return new Headers(input.headers);
  }

  return new Headers();
}

export function isStaleServerActionResponse(
  requestHeaders: Headers,
  response: Pick<Response, "headers">
): boolean {
  return (
    requestHeaders.has(NEXT_ACTION_HEADER) &&
    response.headers.get(NEXT_ACTION_NOT_FOUND_HEADER) === "1"
  );
}
